import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import * as licensesCommonService from '../services/licensesCommon';

const initialState = {
  isExtraInfoFetching: false,
  extraInfo: {},
  extraInfoFetchingError: null,
};

const sliceName = 'licensesCommon';

export const fetchLicenseExtraInfo = createAsyncThunk(
  `${sliceName}/fetchExtraInfo`,
  (args, thunkAPI) => {
    return licensesCommonService.getLicenseExtraInfo(args.productName, args.supportExpirationDate)
      .catch((error) => {
        error.clientMessage = "Can't get info from server";
        return thunkAPI.rejectWithValue(error)
      });
  }
)

const slice = createSlice({
  name: sliceName,
  initialState,
  reducers: {},
  extraReducers: {
    [fetchLicenseExtraInfo.fulfilled]: (state, action) => {
      state.isExtraInfoFetching = false;
      state.extraInfo = action.payload;
    },
    [fetchLicenseExtraInfo.pending]: (state) => {
      state.isExtraInfoFetching = true;
      state.extraInfoFetchingError = null;
    },
    [fetchLicenseExtraInfo.rejected]: (state, action) => {
      state.isExtraInfoFetching = false;
      state.extraInfoFetchingError = action.payload;
    },
  }
});

const { reducer } = slice;

export const licensesCommonSelectors = {
  state: (state) => state[sliceName],
}

export default reducer;



// WEBPACK FOOTER //
// ./src/store/licensesCommonSlice.js